import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Modal, Form, Input, AutoComplete, message } from 'antd';
import axios from 'axios';

import { addGhostSupplier, resetGhostSupplier, resetSupplierError } from './actions';
import { URL_ENDPOINT, MKT_BASE_CURRENCY, COUNTRY_CODE } from '../../index';

const FormItem = Form.Item;
const { Option } = AutoComplete;

const isSingapore = MKT_BASE_CURRENCY === "SGD";

class SupplierModal extends React.Component {
	render() {

		const { visible, ghostSupplier } = this.props;
		const { loading } = ghostSupplier;
		const { address } = this.state;
		const { getFieldDecorator } = this.props.form;

		return (
			<Modal
				title="Add a ghost supplier"
				onCancel={() => this.props.handleCancel(loading)}
				visible={visible}
				confirmLoading
				footer={this.renderFooter(loading)}
			>

				{visible ?
					<Form >
						{/* Contact Person */}
						<FormItem >
							{getFieldDecorator('details.name', {
								rules: [{ required: true, message: 'Please input the contact person!' }],
							})(
								<Input disabled={loading} placeholder="Contact Person" />
							)}
						</FormItem>

						{/* Hand Phone */}
						<FormItem>
							{getFieldDecorator('details.hp', {
								rules: [{ required: true, message: 'Please input the contact number!' }],
							})(
								<Input disabled={loading} placeholder="Contact Number" />
							)}
						</FormItem>

						{/* Contact Email */}
						<FormItem>
							{getFieldDecorator('details.email', {
								rules: [
									{ required: true, message: 'Please input the contact email!' },
									{ type: 'email', message: 'The input is not valid E-mail!' },
									{
										validator: (rule, value, callback) => {
											axios({
												method: 'post',
												url: `${URL_ENDPOINT}/api/user/check/email`,
												data: {
													email: value,
												}
											}).then(res => {
												callback();
											}).catch(err => {
												callback(new Error('Email already exist!'));
											});
										}
									}
								],
							})(
								<Input disabled={loading} placeholder="Contact Email" />
							)}
						</FormItem>

						{/* Contact Person */}
						<FormItem>
							{getFieldDecorator('details.companyName', {
								rules: [{ required: true, message: 'Please input the contact name!' }],
							})(
								<Input disabled={loading} placeholder="Company Name" />
							)}
						</FormItem>

						{/* Postal Code */}
						<FormItem>
							{getFieldDecorator('details.postalCode', {
								rules: [
									{ required: true, message: 'Please input the postal code!' },
									{/* { type: 'integer', message: 'Postal codes only consist of numbers.' } */ }
								],
							})(
								<Input
									type="number"
									disabled={loading}
									onChange={this.handleSearch}
									placeholder="Postal Code" />
							)}
						</FormItem>

						{/* Address */}
						<FormItem>
							{getFieldDecorator('details.address', {
								rules: [
									{ required: true, message: 'Please input address!' },
								],
							})(
								<Input
									value={address.data.ADDRESS}
									disabled={isSingapore}
									placeholder="Address" />
							)}
						</FormItem>

						{/* Unit Number */}
						<FormItem>
							{getFieldDecorator('details.unit', {
								rules: [{ required: true, message: 'Please input the unit number!' }],
							})(
								<Input prefix={"#"} disabled={loading} placeholder="Unit Number" />
							)}
						</FormItem>

						{/* Postal Code */}
						{/* <FormItem>
								{getFieldDecorator('details.postalCode', {
									rules: [{ required: true, message: 'Please input the postal code!' }],
								})(  
									<AutoComplete 
										dataSource={address.data.map(this.renderOption)}
										onChange={this.handleSearch} 
										onSelect={ (value) => { 
											 setFieldsValue({['details.postalCode']: value}) 
											 console.log() 
										}}
										placeholder="Postal Code" >
											<Input />
									</AutoComplete>
								 )} 
							</FormItem>     */}

						{/* Address */}
						{/* <FormItem>
								{getFieldDecorator('details.address', {
									rules: [{ required: true, message: 'Please input the postal code!' }],
								})( 
									<AutoComplete 
										dataSource={address.data}
										onChange={this.handleSearch} 
										onSelect={ (value) => { console.log(value)}}
										placeholder="Postal Code" >
										<Input />
									</AutoComplete>
								)} 
							</FormItem>   */}



					</Form> :
					''

				}
			</Modal>
		);
	}

	renderFooter(loading) {
		return [
			<Button
				disabled={loading}
				onClick={this.props.handleCancel}
				key="cancel">Cancel</Button>,
			<Button
				loading={loading}
				onClick={this.handleAddGhostSupplier}
				type="primary"
				key="submit">Add</Button>
		];
	}

	constructor(props) {
		super(props);

		this.state = {
			address: {
				data: [],
				loading: false
			}
		};
	}

	componentWillReceiveProps(props) {

		if (props.ghostSupplier.error) {

			message.error(props.ghostSupplier.error.message);

			props.resetSupplierError();
		}

		if (props.ghostSupplier.success) {
			const loading = false;
			this.props.resetGhostSupplier(loading);
			this.props.history.push('/supplier');
		}

	}

	renderOption = (item, index) => {

		return (
			<Option key={`${item.POSTAL}`} text={item.POSTAL}>
				{item.ADDRESS}
			</Option>
		);

	};

	handleAddGhostSupplier = () => {

		this.props.form.validateFields((err, values) => {

			if (err) {
				return;
			}

			if (isSingapore && this.state.address.data.length === 0) {
				return this.props.form.setFields({
					'details.postalCode': {
						value: "",
						errors: [new Error('Please key in a valid Postal Code!')]
					}
				});
			}

			this.props.addGhostSupplier({
				details: {
					...values.details,
					address: this.state.address.data.ADDRESS,
					countryCode: COUNTRY_CODE
				}
			});


		});
	};

	handleSearch = (event) => {

		const value = event.target.value;

		if (value.length === 0) {
			return this.setState({
				address: {
					data: {},
					loading: false
				}
			});
		}

		axios({
			url: `https://developers.onemap.sg/commonapi/search?searchVal=${value}&returnGeom=Y&getAddrDetails=Y&pageNum=1`
		})
			.then(res => {

				const data = res.data.results.filter((thing, index, self) => self.findIndex((t) => { return t.POSTAL === thing.POSTAL; }) === index);

				this.setState({
					address: {
						loading: false,
						data: data[0] || [],
						// data: data.map( result => {
						// 	return {
						// 		...result,
						// 		ADDRESS: `${result.BLK_NO} ${result.ROAD_NAME}${result.BUILDING === "NIL"?' ': ` ${result.BUILDING}`}`
						// 	}
						// })
					}
				});

			});
	};

}

export default connect(
	state => ({
		ghostSupplier: state.ghostSupplier
	}),
	dispatch => ({
		addGhostSupplier: (supplierDetails) => dispatch(addGhostSupplier(supplierDetails)),
		resetGhostSupplier: () => dispatch(resetGhostSupplier()),
		resetSupplierError: () => dispatch(resetSupplierError())
	})
)(
	Form.create()(
		withRouter(SupplierModal)
	)
);


// WEBPACK FOOTER //
// ./src/components/supplier/modal.js